// @flow

import React from 'react';
import ReactDOM from 'react-dom';

import { Controller } from './controller';
import { PublicEventBusContext, PublicEventBus } from './public-event-bus';

export class Tectonics {
  bus = new PublicEventBus();
  el = document.createElement('section');

  constructor(hash?: string, lookAndFeelCode?: string, localTenancy?: string) {
    if (!hash) {
      throw new Error('Tectonics - missing hash');
    }

    ReactDOM.render(
      <PublicEventBusContext.Provider value={this.bus}>
        <Controller hash={hash} lookAndFeelCode={lookAndFeelCode} localTenancy={localTenancy} />
      </PublicEventBusContext.Provider>,
      this.el
    );
  }

  renderTo(root: HTMLDivElement) {
    const { el } = this;
    if (el.parentElement !== root) {
      root.appendChild(el);
    }
  }

  destroy() {
    const { el } = this;
    el.remove();
    ReactDOM.unmountComponentAtNode(el);
  }

  on = this.bus.on.bind(this.bus);
  off = this.bus.off.bind(this.bus);
  trigger = this.bus.trigger.bind(this.bus);
}

window.Tectonics = Tectonics;
